// Event that are published to Ocpus platform
// approved by admin, host application open
export const isEventPublished = (
	event: TGetAllEventCommon | TSingleLiveEventData
) => {
	return !event.isHostApplicationAccepted && event.isApproved;
};
